
import { ILoggingService } from '@/services/LoggingService'
import { AggregateFieldModel } from '@/types/FormulaFieldType'
import { PagedListModel } from '@/types/utilTypes'
import axios from 'axios'


export interface IAggregateFieldService {
    upsert(aggregateField: AggregateFieldModel): Promise<void>
    getAll(page: string): Promise<PagedListModel<AggregateFieldModel>>
    delete(id: string): Promise<void>
}

export default class AggregateFieldService implements IAggregateFieldService {
    private readonly _logging: ILoggingService
        private baseUrl = '/aggregate-field'
    
        constructor(logging: ILoggingService) {
            this._logging = logging
        }

        public async getAll(page: string): Promise<PagedListModel<AggregateFieldModel>> {
            const url = `${this.baseUrl}/${page}`

            try {
                return (await axios.get<PagedListModel<AggregateFieldModel>>(url)).data
            } catch(error){
                this._logging.LogError(url, error)
                throw error
            }
        
        }

        public async upsert(aggregateField: AggregateFieldModel): Promise<void> {
            const url = `${this.baseUrl}`
            try {
                await axios.post(url, aggregateField)
            } catch(error){
                this._logging.LogError(url, error)
                throw error
            }
        }

        public async delete(id: string): Promise<void> {
            const url = `${this.baseUrl}/${id}`
            try {
                await axios.delete(url)
            } catch(error){
                this._logging.LogError(url, error)
                throw error
            }
        }
    
}